<template>
  <div
    class="payment-thermal-real"
    style="border: none"
    :id="isPrint ? 'print-thermal' : ''"
  >
    <div
      class="print-section struct-wrapper"
      :style="isPrint ? `height: ${height}; width: ${width};` : ''"
      style="
        position: absolute;
        background-color: white;
        inset: 0px;
        margin: 0px !important;
        padding: 0px !important;
        width: 68mm;
        font-family: monospace, monospace;
        font-weight: 400 !important;
        color: black;
        width: 68mm !important;
        font-size: 12px !important;
      "
    >
      <div class="row justify-content-between align-items-center">
        <div class="col-md-12 text-center">
          <ImageComponent place="logo-invoice-thermal-print"></ImageComponent>
          <div class="font-weight-light testert" style="font-size: 9pt">
            {{ setting.clinic_address }}
          </div>
          <div
            class="font-weight-light"
            style="font-size: 9pt; font-weight: bold"
          >
            {{ setting.phone }}
          </div>
          <div class="thermal-real-status">
            {{ data.document_status_label || "BELUM DIBAYAR" }}
          </div>
          <div v-if="data.is_copy" class="thermal-real-copy">
            *** SALINAN ***
          </div>
        </div>

        <div class="col-12">
          <span>------------------------------</span>
          <table style="font-size: 9pt !important">
            <tr>
              <td style="width: 100px">Nomor</td>
              <td style="width: 9px">:</td>
              <td>{{ data.invoice_number || data.id }}</td>
            </tr>
            <tr>
              <td>Tanggal</td>
              <td style="width: 9px">:</td>
              <td>{{ data.display_created_at }}</td>
            </tr>
            <tr>
              <td>Nama Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_name }}</td>
            </tr>
            <tr v-if="data.sub_patient_id != null">
              <td>Nama Sub Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.sub_patient_name }}</td>
            </tr>
            <tr>
              <td>Nomor HP</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_mobile_phone }}</td>
            </tr>
            <tr>
              <td>Dokter</td>
              <td style="width: 9px">:</td>
              <td>{{ data.doctor_name }}</td>
            </tr>
          </table>
        </div>
      </div>
      <span>------------------------------</span>
      <div style="font-size: 9pt">
        <div class="row thermal-items">
          <!-- item -->
          <div
            class="col-md-12 thermal-line-item"
            v-for="(data, index) in items"
            :key="index"
          >
            <span class="thermal-line-item__name">{{ data.name }}</span>
            <div class="thermal-line-item__calculation">
              <span
                >{{ data.quantity }} x
                {{
                  parseInt(
                    data.price - data.promo_amount + data.discount_amount
                  ).toLocaleString("id-ID")
                }}</span
              >
              <span>
                {{
                  parseInt(
                    (data.price - data.promo_amount + data.discount_amount) *
                      data.quantity
                  ).toLocaleString("id-ID")
                }}
              </span>
            </div>
            <div
              class="thermal-line-item__discount"
              v-if="data.discount_amount != 0"
            >
              <span
                >Disc.
                {{
                  parseInt(data.discount_amount).toLocaleString("id-ID")
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="min-height: 285px; font-size: 7pt">
        <div class="row">
          <div class="col-md-12">
            <b-table borderless small :items="items" :fields="fields" style="font-size: 8pt !important">
              <template #table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" />
              </template>
              <template #cell(price)="data">
                {{
                  "Rp " +
                  parseInt(
                    parseInt(data.item.price) + data.item.discount_amount
                  ).toLocaleString("id-ID")
                }}
              </template>
              
              <template #cell(subtotal)="data">
                <span class="d-block">
                  {{
                    "Rp " +
                    parseInt(
                      data.item.price * data.item.quantity
                    ).toLocaleString("id-ID")
                  }}
                </span>
                <span class="d-block" v-if="data.item.discount_amount != 0"
                  >Disc : Rp
                  {{
                    `${parseInt(data.item.discount_amount).toLocaleString(
                      "id-ID"
                    )} ${
                      data.item.discount_type == 1 &&
                      (data.item.discount_amount != 0 ||
                        data.item.discount_percentage != 0)
                        ? `(${parseInt(data.item.discount_percentage)})%`
                        : ""
                    }`
                  }}</span
                >
              </template>
            </b-table>
          </div>
        </div>
      </div> -->
      <span>------------------------------</span>
      <div class="row" style="font-size: 9pt">
        <div class="col-md-12 py-0">
          <span class="font-weight-bold d-block">Catatan :</span>
        </div>
        <div class="col-md-12 pt-1">
          <span>{{ data.notes }}</span>
        </div>
      </div>
      <span>------------------------------</span>
      <div class="d-flex align-items-center">
        <div class="mr-2">
          <!-- Notes -->
          <!-- <div
            class="form-group"
          >
            <label for="notes">Catatan:</label>
            <textarea
              name=""
              id="notes"
              cols="30"
              rows="3"
              class="form-control"
              style="resize: none"
              v-model="data.notes"
              readonly
            ></textarea>
          </div> -->
        </div>
        <table v-if="showSummary" style="font-size: 9pt !important">
          <tr>
            <td style="width: 150px">Subtotal</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.total_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Diskon</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.discount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Biaya Tambahan</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.surcharge).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr v-if="data.coupon_amount">
            <td>Kupon</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.coupon_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Total</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.final_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr v-if="numberValue(data.paid_amount) > 0">
            <td>Terbayar</td>
            <td>Rp</td>
            <td class="text-right">
              {{ numberValue(data.paid_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
          <tr v-if="numberValue(data.refunded_amount) > 0">
            <td>Refund</td>
            <td>Rp</td>
            <td class="text-right">
              {{ numberValue(data.refunded_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
          <tr v-if="numberValue(data.unpaid_amount) > 0">
            <td>Sisa</td>
            <td>Rp</td>
            <td class="text-right">
              {{ numberValue(data.unpaid_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
        </table>
      </div>
      <div class="thermal-real-footer">
        Dicetak {{ printTime }}<br /><span v-if="data.created_by_name"
          >Kasir: {{ data.created_by_name }}</span
        ><br /><span v-if="data.guarantee_reference"
          >Ref: {{ data.guarantee_reference }}</span
        >
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center p-0 mt-n3">
      <div>
        <hr class="special-hr" style="margin: 2px" />
        <div>{{ currentUserPersonalInfo.name }}</div>
      </div>
    </div> -->
    <!-- <div class="d-flex justify-content-center p-0 mt-n3">
      <div>
        <hr class="special-hr" style="margin: 2px" />
        <div>{{ currentUserPersonalInfo.name }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageComponent from "@/component/general/ImageComponent.vue";

export default {
  props: {
    data: Object,
    height: String,
    width: String,
    isPrint: Boolean,
    setting: Object,
    items: Array,
    renderNotes: Boolean,
    showSummary: Boolean,
    notes: String,
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    printTime() {
      return new Date().toLocaleString("id-ID");
    },

    mutated_total_amount: {
      set(newValue) {
        this.data.total_amount = newValue;
      },
      get() {
        let amount = this.data.total_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },

    mutated_final_amount: {
      set(newValue) {
        this.data.final_amount = newValue;
      },
      get() {
        let amount = this.data.final_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },
  },

  components: {
    ImageComponent,
  },

  data() {
    return {
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Ket",
        },
        {
          key: "quantity",
          label: "Jml",
        },

        {
          key: "price",
          label: "Nett",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "subtotal",
          label: "Subtotal",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    numberValue(value) {
      const n = Number(value || 0);
      return Number.isFinite(n) ? n : 0;
    },
  },
};
</script>

<style scoped>
.thermal-real-status {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 5px;
  border: 1px solid #000;
  font-weight: 900;
}
.thermal-real-copy {
  margin-top: 2px;
  font-weight: 900;
}
.thermal-real-footer {
  margin-top: 8px;
  padding-top: 5px;
  border-top: 1px dashed #000;
  text-align: center;
  font-size: 8pt;
  line-height: 1.3;
  overflow-wrap: anywhere;
}
.special-hr {
  border-color: #000000;
  border-style: solid;
  border-width: 2px 0 0;
  clear: both;
  margin: 0 0 0px;
  height: 0;
}
</style>

<style></style>
<style scoped>
.payment-thermal-real,
.payment-thermal-real table,
.payment-thermal-real [style*="font-size"] {
  font-size: 9pt !important;
  line-height: 1.25 !important;
}

.payment-thermal-real .py-1 {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

.thermal-line-item {
  margin-bottom: 7px;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.thermal-items {
  width: 100%;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.thermal-line-item__name {
  display: block;
  overflow-wrap: anywhere;
  font-weight: 600;
  line-height: 1.3;
}
.thermal-line-item__calculation {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
  padding: 0 4px;
  line-height: 1.3;
}
.thermal-line-item__calculation span:last-child {
  flex: 0 0 auto;
  text-align: right;
  white-space: nowrap;
}
.thermal-line-item__discount {
  margin-top: 2px;
  padding: 0 4px;
  text-align: right;
}
</style>
